export default "__VITE_ASSET__bL07ivNV__"